import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import * as authActions from 'services/auth/actions'
import Login from './Login'
import styles from '../_auth.css'
import * as auth from 'services/auth/selectors'
import * as bootupSelectors from 'services/bootup/selectors'
import { selectLocation } from 'services/routing/selectors'
import { goToNext } from 'shared/routes'

const mapStateToProps = (state) => ({
  appConfig: bootupSelectors.selectAppConfig(state),
  onboarding: auth.selectOnboarding(state),
  location: selectLocation(state),
})

const mapDispatchToActions = {
  push,
  ...authActions,
}

export class LoginPage extends Component {

  static propTypes = {
    appConfig: PropTypes.object,
    push: PropTypes.func,
    onboarding: PropTypes.string,
    goToNext: PropTypes.func,
    dispatch: PropTypes.func,
    location: PropTypes.shape({
      search: PropTypes.string,
      query: PropTypes.object,
    }),
  }

  handleClickSignup = () => {
    const { location: { search }} = this.props
    this.props.push({ pathname: '/auth/signup', search })
  }

  handleClickForgotPassword = () => {
    this.props.push('/auth/forgot_password')
  }

  handleLoginSuccess = () => {
    const appConfig = this.props.appConfig
    const onboarding = this.props.onboarding
    const { location: { search, query }} = this.props
    const next = query.next

    if (onboarding) {
      this.props.push({ pathname: '/auth/signup', search })
    } else {
      goToNext(next, appConfig.myHome)
    }
  }

  render () {
    return (
      <div className={styles.container}>
        <Login
          onLoginSuccess={this.handleLoginSuccess}
          onClickSignup={this.handleClickSignup}
          onClickForgotPassword={this.handleClickForgotPassword}
        />
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToActions)(LoginPage)
